import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

const AuthCallback = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Get the session from the URL hash
        const { data: { session }, error } = await supabase.auth.getSession()
        
        if (error) {
          console.error('Auth callback error:', error)
          navigate('/?error=auth_failed')
          return
        }

        if (session) {
          // Successfully authenticated, redirect to dashboard
          navigate('/dashboard')
        } else {
          // No session, redirect to home
          navigate('/')
        }
      } catch (err) {
        console.error('Auth callback error:', err)
        navigate('/?error=auth_failed')
      }
    }

    handleAuthCallback()
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center bg-zenna-cream dark:bg-slate-900">
      <div className="text-center">
        <div className="w-16 h-16 rounded-2xl bg-gradient-zenna flex items-center justify-center mx-auto mb-4 animate-pulse">
          <span className="text-white text-2xl">✨</span>
        </div>
        <h2 className="text-xl font-display font-bold text-slate-900 dark:text-white mb-2">
          Signing you in...
        </h2>
        <p className="text-slate-500 dark:text-slate-400">
          Just a moment while we set things up.
        </p>
      </div>
    </div>
  )
}

export default AuthCallback
